import { uploadImage } from "./imageLoader";
import mainAxios from "../redux/api/mainAxios";

// Function to upload an image and create an image entry
export const uploadAndCreateImageEntry = async (file, reference) => {
  if (!file) return null;

  try {
    // 1. Upload the file to media library

    const uploadedFile = await uploadImage(file);

    // 2. Create an image entry in the images collection
    const imageData = {
      data: {
        name: file.name || `Image for ${reference}`,
        origine: "novanea",
        origine_id: reference,
        origine_url: uploadedFile.url,
        image: [uploadedFile.id],
      },
    };

    const imageEntryResponse = await mainAxios.post(`api/images`, imageData);

    if (!imageEntryResponse.data || !imageEntryResponse.data.data) {
      throw new Error("Failed to create image entry");
    }

    // Return the image entry data with its ID
    return imageEntryResponse.data.data;
  } catch (error) {
    console.error("Error in uploadAndCreateImageEntry:", error);
    throw error;
  }
};
